<!-- 调查问卷结果标注 -->
<template>
  <div class="content" v-loading="tableLoading">
    <!-- 搜索区域start -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div" >
            <span style="color: red">*</span>选择任务
          </div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.taskDetailGuid"
            placeholder="请选择"
            collapse-tags
            reserve-keyword
            clearable
            filterable
            multiple
            @change="taskChange"
          >
            <el-option
              v-for="item in taskList"
              :key="item.guid"
              :label="item.taskTitle + ' | ' + item.taskContentName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">
            <span style="color: red">*</span>选择问卷
          </div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.surveyTenantGuid"
            filterable
            @focus="selectSurveyFocus"
            placeholder="请选择"
          >
            <el-option
              v-for="item in surveyList"
              :key="item.guid"
              :label="item.surveyTitle"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">
            <span style="color: red">*</span>审核状态
          </div>
          <el-select
            size="mini"
            class="ipt-sty"
            v-model="page.approveState"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in approveStateOption"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="goSearch">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
        
      </el-row>
      
    </div>
    <!-- 搜索区域end -->

    
    <!-- 内容区域start -->
    <template >
      
      <!-- 问卷分析 -->
      <div class="no-data" v-if="tableData.length == 0">
        <img src="../../assets/images/no_data.png" alt="" />
      </div>
      <div class="back-color-fff" v-else>
        <div class="task-item" v-for="(item, index) in tableData">
          <div style="text-align: left">
            <div style="font-weight: 700; font-size: 18px; padding-bottom: 10px; font-family: 微软雅黑">
              {{ `第${index + 1}题: ${item.subjectTitle}【${item.subjectType}】` }}
            </div>
            <div v-if="item.tagJson&&item.tagJson.length>0">
              <div class="read-box" v-if="item.tagType==1">
                <p style="font-size: 12px;margin: 0 0 10px;">
                  输入标签列数：
                <el-input-number v-model="item.columnNum" @change="handleChange(item)" :min="1" size="mini"></el-input-number>
                </p>
                <el-table
                  :data="item.tagJson"
                  stripe
                  border 
                  tooltip-effect="light"
                  >
                  <el-table-column
                    prop="answerTxt"
                    label="问卷答案"
                    width="180">
                  </el-table-column>
                  <el-table-column 
                    prop="answerTxt" 
                    width="160" 
                    :label="'标签'+col+'（可修改）'" 
                    show-overflow-tooltip 
                    header-align="left" 
                    align="left"
                    v-for="(col,idx) in item.columnNum"
                    >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row[idx]"
                        placeholder="请输入"
                        size="mini"
                        @input="inputChange($event,scope.row,idx,item)"
                      ></el-input>
                      <!-- 
                        @change="changeLabel(scope.row, index)" -->
                      <!-- {{ scope.row['column_' + index] || '-' }} -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="read-box num-box" v-if="item.tagType==2">
                <!-- 模拟数值 -->
              
                <el-table
                  :data="item.tagJson"
                  stripe
                  border 
                  tooltip-effect="light"
                  >
                  <!-- <el-table-column 
                    prop="minNum" 
                    width="150" 
                    label="标签（可修改）" 
                    show-overflow-tooltip 
                    :key="item">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.tagName[0]"
                        placeholder="请输入"
                        size="mini"
                        @change="changeLabel(scope.row, index)"
                      ></el-input>
                      {{ scope.row['column_' + index] || '-' }}
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="minNum"
                    label="最小值（不包含）"
                    width="140">
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.minNum"
                        placeholder="请输入"
                        size="mini"
                        :controls="false"
                        @input="numChange(scope.row,'minNum')"
                      ></el-input-number>
                      <!-- {{ scope.row['column_' + index] || '-' }} -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="maxNum"
                    label="最大值（包含）"
                    width="140">
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.maxNum"
                        placeholder="请输入"
                        size="mini"
                        :controls="false"
                        @input="numChange(scope.row,'maxNum')"
                      ></el-input-number>
                      <!-- {{ scope.row['column_' + index] || '-' }} -->
                    </template>
                  </el-table-column>
                </el-table>
                
              </div>
            </div>
            <div v-else>
              <div class="no-data">
                暂无数据
              </div>
            </div>
            <div>
            
            </div>
          </div>
          
        </div>
        <div class="operte-btns">
          <div  class="btn submit" @click="saveReq()">保存</div>
          <div  class="btn cancel" @click="getList()">取消</div>
        </div>
        
      </div>
    </template>
    <!-- 内容区域end -->
  </div>
</template>

<script>
import QuestionnaireAnalysis from './components/QuestionnaireAnalysis.vue';
import { route } from '@/api/apiRoute';
import store from '@/store';
import qs from 'qs';
import { $eventBus } from './utils/eventBus';
export default {
  components: {
    QuestionnaireAnalysis,
  },
  data() {
    return {
      // searchShow: false,
      // checkboxGroupList: [],
      // activeName: '1',
      // fullscreenLoading: false,
      // timeRange: [],
      tableLoading: false,
      page: {
        // pageIndex: 1,
        // pageSize: 10,
        // totalPage: 0,
        // totalRows: 0,
        tenantGuid: '',
        // staffGuid: '',
        taskDetailGuid: [],//选择任务
        surveyTenantGuid: null,//选择问卷
        approveState:['Y','P'],//审核状态
      },
      // currentSurver: {}, // 当前问卷item
      surveyList: [],
      // surveyReport: [], // 问卷分析导出的内容
      // surveyGuid: null,
      // height: window.innerHeight - 260,
      // right: 'right',
      tableData: [],
      // tableDataAll: null,
      // dialogVisible: false,
      // taskGuid: '',
      taskList: [],
      selectTask: [],//选择的任务
      // organisationGuid: null,
      tenantGuid: null,//选择的任务的企业id
      // taskMainGuids: [], // 任务id
      // billCycleData: [], // 账单周期列表
      // accountMonth: '',
      //批量导入
      // showImport: false,
      // currentStep: 0,
      // importResult: '',
      // importLoading: false,
      // surveyReportLoading: false,
      // fileList: [], //上传的文件
      approveStateOption: [
        // 是否结算 option
        // { name: '全部', value: 'all' },
        { name: '合格', value: 'Y' },
        { name: '部分合格', value: 'P' },
        { name: '不合格', value: 'N' },
      ],
    };
  },
  created() {
    this.getTaskList();
  },
  watch: {},
  methods: {
    
    //获取任务
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        taskContentType: ['WJDC'],
        serviceTenantGuid: localStorage.guid,
      };
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/task/data/get/tenant-task-detail-list`, query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.taskList = res.data.data && res.data.data.records ? res.data.data.records : [];
            if (this.taskList.length > 0) {
              this.page.taskDetailGuid = [this.taskList[0].guid]; // 多选设置
              // this.organisationGuid = [this.taskList[0].organisationGuid]; // 多选设置
              
              this.tenantGuid = this.taskList[0].tenantGuid;
              this.taskChange(this.page.taskDetailGuid);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取问卷列表
    getSurveyList() {
      this.tableLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: this.tenantGuid,
        taskDetailGuids: this.page.taskDetailGuid,
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/survey/report/get-by-task`, query).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.length > 0) {
            this.surveyList = res.data.data;
            this.page.surveyTenantGuid = this.surveyList[0].guid;
          } else {
            this.surveyList = [];
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取周期计算
    // async getCycleDataList() {
    //   let accountMonth = await this.getAccountMonth();
    //   this.accountMonth = accountMonth || [];
    //   let param = {
    //     tenantGuid: this.tenantGuid,
    //     accountMonth: this.accountMonth,
    //   };
    //   this.api
    //     .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle-by-months`, param)
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         this.billCycleData = res.data.data || [];
    //         if (this.billCycleData && this.billCycleData.length > 0) {
    //           this.billCycleData.forEach((i, index) => {
    //             if (!i) {
    //               this.billCycleData[index] = '全部';
    //             }
    //           });
    //         }
    //         console.log('this.',this.billCycleData);
            
    //       } else {
    //         this.$message.error(res.data.msg);
    //       }
    //     });
    // },
    // getAccountMonth() {
    //   let query = {
    //     tenantGuid: this.tenantGuid,
    //     taskDetailGuids: this.page.taskDetailGuid,
    //   };
    //   return new Promise((resolve, reject) => {
    //     this.api
    //       .postJson(`/${serverConfig.msSalesPerformService}/survey/report/account-month/get-by-task`, query)
    //       .then((res) => {
    //         if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //           resolve(res.data.data);
    //         } else {
    //           reject(null);
    //           this.$message.error(res.data.msg);
    //         }
    //       });
    //   });
    // },
    taskChange(guidList) {
      // 获取相同公司的任务
      if (guidList && guidList.length) {
        // this.taskMainGuids = [];
        this.selectTask = [];
        guidList.forEach((i) => {
          let oneTask = this.taskList.find((item) => item.guid === i);
          if (oneTask) this.selectTask.push(oneTask);
        });
        this.tenantGuid = this.selectTask[0] && this.selectTask[0].tenantGuid ? this.selectTask[0].tenantGuid : '';
        if (!this.selectTask.every((item) => this.tenantGuid === item.tenantGuid)) {
          this.$message.error('请选择相同公司');
          this.page.taskDetailGuid.pop();
          return;
        }
        // this.selectTask.forEach((item) => {
        //   this.taskMainGuids.push(item.taskMainGuid);
        // });
        // this.billCycleData = [];
        // this.page.billCycle = [];
        // this.page.accountMonth = '';
        this.page.surveyTenantGuid = null;
        this.page.tenantGuid = this.tenantGuid;
        // this.page.billCycleTaskValid = 'N';
        // this.getCycleDataList(); // 获取账单周期
        this.getSurveyList();
        this.$forceUpdate();
      }
    },
    selectSurveyFocus() {
      if (!this.page.taskDetailGuid||!this.page.taskDetailGuid.length) {
        this.$message.error('请先选择任务！');
      }
    },
    
    goSearch() {
      if (!this.surveyList.length) {
        this.$message.error('请选择任务与问卷！');
        return;
      }
      if (!this.page.surveyTenantGuid && !this.page.taskDetailGuid) {
        this.$message.error('请选择任务与问卷！');
        return;
      }
      this.getList();
      
    },
    toList(str){
      let list=[]
      list=JSON.parse(str)
      console.log('li',list);
      
      return list;
    },
    
    getList() {
      let self = this;
      self.tableLoading = true;
      let param = JSON.parse(JSON.stringify(this.page));
      
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/survey/tag/listTag`, param)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data&&res.data.data.length>0){
              self.tableData = res.data.data
              if(self.tableData.length>0){
                // columnNum
                self.tableData.forEach((item) => {
                  // item.columnNum = 1;
                  // item.tagJson = JSON.parse(item.tagJson);
                  this.$set(item,'tagJson',JSON.parse(item.tagJson))
                  // console.log('item.tagJson',item.tagJson);
                  
                  if(item.tagType=='1'){//文本
                    item.tagJson.forEach((obj) => {
                      if(obj.tagName&&obj.tagName.length>0){
                        item.columnNum=obj.tagName.length
                        obj.tagName.forEach((obj2,idx)=>{
                          this.$set(obj,idx,obj2)
                        })

                      }else{
                        obj.tagName=['']
                        this.$set(obj,'0','')
                        item.columnNum=1
                      }
                      
                    });
                  }
                });
              }
              console.log('tableData',self.tableData);
            }else{
              self.$message.error('暂无数据');
              self.tableData = [];
            }
           
            // self.page.totalPage = res.data.data.data.totalPages;
            // self.page.totalRows = res.data.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //提交申请
    saveReq() {
      let self = this;
      console.log('self.tableData',self.tableData);
      try{
        self.tableData.forEach((item) => {
          if(item.tagJson&&item.tagJson.length>0){
            item.tagJson.forEach(obj=>{
              if(item.tagType=='1'&&obj.tagName&&obj.tagName.length>0){
                if(obj.tagName.includes('')){
                  throw new Error('标签名称不能为空');
                }
              }
              if(item.tagType=='2'){
                if(obj.minNum!=0&&obj.maxNum!=0&&(!obj.minNum||!obj.maxNum)){
                  throw new Error('最大值/最小值不能为空');
                }
              }
            })
          }
        });
      }catch(e){
        this.$message.warning(e.message);
        return;
      }
      
      console.log('77');
      
      let params=JSON.parse(JSON.stringify(this.tableData));
      params.forEach((item) => {
          if(item.tagJson&&item.tagJson.length>0){
            item.tagJson=JSON.stringify(item.tagJson);
          }
        });
      
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tag/saveTag`, params).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('提交成功');
          self.getList()
          // self.$refs[formName].resetFields();
          // if (flg == 1) {
          //   self.reset();
          // } else {
          //   self.$router.push({
          //     path: '/pharmacy',
          //     query: { tenantGuid: self.$route.query.tenantGuid },
          //   });
          // }
        } else {
          self.$message.error(res.data.msg);
        }
      });
       
    },
    
    emptySearch() {
      // if(!this.surveyList.length){
      //   this.$message.error('暂无问卷')
      //   return
      // }
      this.page = {
        // pageIndex: 1,
        // pageSize: 10,
        // totalPage: 0,
        // totalRows: 0,
        taskDetailGuid: [],//选择任务
        surveyTenantGuid: null,//选择问卷
        approveState:['Y','P'],//审核状态
        tenantGuid: '',
        // staffGuid: '',
        // startTime: '',
        // endTime: '',
        
        // accountMonth: '',
        // billCycleTaskValid:'N'
      };
      // this.timeRange = [];
      this.tableData = [];
      this.surveyList = [];
      // this.billCycleData = [];
      // this.page.billCycle = ''
      // this.getList();
    },
    handleChange(item) {
      console.log(778,item);
      if(item.tagJson.length>0){
        item.tagJson.forEach((col,idx) => {
          console.log('col',col);
          // 如果是新增一列2-3
          if(!col[item.columnNum-1]){
            this.$set(col,item.columnNum-1,'')
            this.$set(col.tagName,item.columnNum-1,'')
          }
          if(item.columnNum in col){
            // 如果是减少一列3-2
            console.log('col[item.columnNum]',item.columnNum,col[item.columnNum]);
            col.tagName.length--
            delete col[item.columnNum]
          }
          
          // col.tagName.length=item.columnNum
          // col.tagName.forEach((tag,idx) => {
          //   console.log('tag[idx]',tag[idx]);
          //   this.$set(tag,idx,tag[idx]||'')
            
          //   // tag[idx]=tag[idx]||''
          //   // col[idx]=tag||'';
          // });
      });
      }
      this.$forceUpdate()
    },
    inputChange(e,row,idx,item) {
      //强制刷新
      console.log('input',e,row,idx,item);
      this.$set(row.tagName, idx, e)
      this.$forceUpdate()
    },
    numChange(row,key) {
      if(row.minNum>=row.maxNum){
        this.$message.warning('最小值不能大于最大值')
        row[key]=undefined
        this.$forceUpdate()
      }
      console.log('input',row,key);
    }
  },
};
</script>


<style lang="less" scoped>
.back-color-fff{
  height: calc(100vh - 60px - 35px - 66px - 30px);
  overflow-y: auto;
  padding: 20px 60px;
}
.process-list {
  background: #fff !important;
  overflow-y: auto;
}
.content h1 {
  margin: 0;
  margin-bottom: 16px;
  font-size: 18px;
}
.operte-btns {
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}

/deep/ .el-tabs__header {
  margin: 0 0 1px;
}
/deep/ .el-tabs__nav-scroll {
  padding-left: 20px;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #e9eef3;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/* 导入 */
.importClass .firstStep {
  text-align: left;
  margin-top: 50px;
}

.importClass .firstStep .el-row {
  margin-bottom: 50px;
}

.importClass .firstStep .el-col-6 {
  text-align: right;
}

.importClass .firstStep .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 290px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}
.downloadTemplate {
  color: #fff;
  background: #4fa1a4;
  padding: 9px 15px;
  border-radius: 3px;
  display: inline-block;
}
.survey-state-yes {
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #649fa4;
  font-size: 12px;
  background: rgba(234, 246, 247, 0.39);
  border: 1px solid #b0d0d3;
  border-radius: 2px;
}
.survey-state-no {
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #ff2121;
  font-size: 12px;
  background: rgba(255, 244, 244, 0.39);
  border: 1px solid #ffdede;
  border-radius: 2px;
}
/deep/.el-progress {
  display: flex;
}
/deep/.el-progress__text {
  flex-shrink: 0;
}
.search-area .search-area-div{
  flex-shrink: 0;
  width:70px;
  text-align: right;
  margin-right: 2px;
}
.read-dialog .search-area-div{
  width:60px!important;
}
.ipt-sty{
  flex: 1;
}
.el-col-6 ,.el-col-4{
  display: flex;
  justify-content: flex-start;
  // margin-bottom: 12px;
}
.el-col-20{
  display: flex;
  justify-content: flex-start;
  // margin-bottom: 12px;
}
.el-col-8{
  display: flex;
  // margin-bottom: 15px;
  justify-content: flex-end;
}

.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.el-col-6 {
  display: flex;
}
/deep/.el-date-editor .el-range__icon {
  margin-left: 5px;
}
.no-data {
  padding: 30px;
  background: #fff;
}
.num-box /deep/ .el-input--mini {
  width: 120px;
}
.read-box /deep/ .el-table {
  font-size: 14px;
  color: #212121;
  margin-bottom: 12px;
}


.read-box /deep/ .el-table__body-wrapper tr, .content-main-box .el-table__body td.el-table__cell {
  height: 40px;
}

/* .content-main-box .el-table__body-wrapper tr td:first-child {
  border-right: 1px solid #D9D9D9;
} */

.read-box /deep/  .el-table .el-table__cell {
  padding: 0px;
}
.read-box /deep/  .el-table .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.read-box /deep/ .el-table--border, .el-table--group{
  border-top: none;
}

.read-box /deep/ .el-table th.el-table__cell {
  background-color: #F2F2F2;
  height: 32px;
  /* border-right: 1px solid #D9D9D9;
  border-top: 1px solid #D9D9D9; */
}
.read-box /deep/ .el-table--border::after, .el-table--group::after{
  width: 0;
}

.read-box /deep/ .el-table th.el-table__cell:last-child {
  border-right: none;
}
.read-box /deep/ .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}

</style>
